import { createContext } from 'react';

const CaptchaContext = createContext();

export default CaptchaContext;
